import { motion } from "framer-motion";
import { isFreePrintEnabled } from "../../services/kioskServiceSession";

// Экран 6 «Подтверждение» из макета, показывается модалкой поверх параметров печати.
function Row({ label, value, total = false }) {
    return (
        <div
            className={`flex items-center justify-between gap-[1.4vw] py-[1.2vh] ${
                total ? "pt-[1.8vh]" : "border-b-[0.2vh] border-[#E1E4EB]"
            }`}
        >
            <span
                className={
                    total
                        ? "text-[1.7vh] font-extrabold text-[#12161F]"
                        : "text-[1.6vh] font-semibold text-[#7B8290]"
                }
            >
                {label}
            </span>
            <span
                className={
                    total
                        ? "text-[3.4vh] font-extrabold tracking-tight text-[#246CE2]"
                        : "text-[1.6vh] font-bold text-right"
                }
            >
                {value}
            </span>
        </div>
    );
}

function PaymentModal({
    setShowModal,
    handlePayment,
    documentName,
    documentsCount,
    printType,
    customPages,
    printColor,
    orientation,
    printSide,
    copyCount,
    scaleMode,
    scalePercent = 100,
    pagesToPrint,
    calculateTotalCost,
    t,
}) {
    const freePrint = isFreePrintEnabled();
    const pagesValue =
        printType === "custom" && customPages
            ? `${t("editDoc.print_types.custom")} · ${customPages}`
            : `${t(`editDoc.print_types.${printType}`)}${
                  pagesToPrint
                      ? ` · ${t("editDoc.pages_count", { count: pagesToPrint })}`
                      : ""
              }`;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(18,22,31,0.45)]"
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.94, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.94, y: 20 }}
                transition={{ duration: 0.28 }}
                className="w-[74vw] bg-white rounded-[4vh] shadow-[0_3vh_8vh_rgba(18,22,31,0.28)] px-[3.6vw] py-[3.2vh] flex flex-col"
            >
                <h2 className="text-center text-[3vh] font-extrabold tracking-tight">
                    {t("editDoc.modal.title")}
                </h2>
                <div className="text-center text-[1.7vh] font-semibold text-[#7B8290] mt-[0.6vh] truncate">
                    {documentName}
                    {documentsCount > 1 && (
                        <span className="ml-[0.8vw]">
                            · {t("editDoc.modal.documents_count", { count: documentsCount })}
                        </span>
                    )}
                </div>

                <div className="mt-[2.4vh] flex flex-col">
                    <Row label={t("editDoc.modal.paper_format")} value="A4" />
                    {scaleMode && <Row label={t("pbreader.scaling.title")} value={scaleMode === "custom" ? `${scalePercent}%` : t(`pbreader.scaling.${scaleMode}`)} />}
                    <Row
                        label={t("editDoc.modal.print_color")}
                        value={t(`editDoc.print_colors.${printColor}`)}
                    />
                    <Row
                        label={t("editDoc.modal.print_side")}
                        value={t(`editDoc.print_sides.${printSide}`)}
                    />
                    <Row
                        label={t("editDoc.modal.orientation")}
                        value={t(`editDoc.orientations.${orientation}`)}
                    />
                    <Row
                        label={t("editDoc.modal.print_type")}
                        value={pagesValue}
                    />
                    <Row
                        label={t("editDoc.modal.copies")}
                        value={copyCount}
                    />
                    <Row
                        label={t("editDoc.modal.total_due")}
                        value={freePrint ? "0 ₸" : `${calculateTotalCost} ₸`}
                        total
                    />
                </div>

                <div className="flex gap-[1vw] mt-[2.4vh]">
                    <button data-analytics="paymentmodal.editDoc.modal.change.1"
                        type="button"
                        onClick={() => setShowModal(false)}
                        className="flex-1 py-[1.8vh] rounded-full bg-[#F1F3F7] text-[1.8vh] font-bold text-[#12161F] active:bg-[#E1E4EB] transition-colors"
                    >
                        {t("editDoc.modal.change")}
                    </button>
                    <button data-analytics="paymentmodal.editDoc.free_print.2"
                        type="button"
                        onClick={handlePayment}
                        className="flex-1 py-[1.8vh] rounded-full bg-[#246CE2] text-[1.8vh] font-bold text-white active:bg-[#1B55B4] transition-colors"
                    >
                        {freePrint ? t("editDoc.free_print") : t("editDoc.modal.pay_kaspi")}
                    </button>
                </div>
            </motion.div>
        </motion.div>
    );
}

export default PaymentModal;
